import { render } from "./BaseRadioButtonV2.vue?vue&type=template&id=fd4a87a4&scoped=true"
import script from "./BaseRadioButtonV2.vue?vue&type=script&lang=js"
export * from "./BaseRadioButtonV2.vue?vue&type=script&lang=js"

import "./BaseRadioButtonV2.vue?vue&type=style&index=0&id=fd4a87a4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4a87a4"]])

export default __exports__